export enum MomentDateType {
  ll = "ll", // DD MMM YYYY. E.g 10 Sep 2020
  LL = "LL", // DD MMMM YYY. E.g 20 September 2020
}
